import { useModal } from "contexts/ModalContext";

// Generic hook for any type of modal
export const useGenericModal = () => {
  const { openModal, closeModal, closeAllModals } = useModal();

  // Open any React component as a modal
  const openGenericModal = (ModalComponent, props = {}, options = {}) => {
    return openModal(
      ({ onClose }) => (
        <ModalComponent {...props} onClose={onClose} closeModal={onClose} />
      ),
      options
    );
  };

  const closeGenericModal = (modalId) => {
    closeModal(modalId);
  };

  return {
    openGenericModal,
    closeGenericModal,
    closeAllModals,
  };
};
